import {Component, OnInit} from "@angular/core";
import {AuthService} from "../auth/auth-service";
import {Router} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";

@Component({
    templateUrl: './logout.component.html',
    imports: [TranslateModule],
    styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {
    constructor(private authService: AuthService, private router: Router) { }

    ngOnInit(): void {
        this.authService.signOut();
        sessionStorage.removeItem("log-on-path");
    }
}
